<script>
    import Icon from 'svelte-awesome';
    import globe from "svelte-awesome/icons/globe";
    import facebook from "svelte-awesome/icons/facebook";
    import instagram from "svelte-awesome/icons/instagram";
    import youtube from "svelte-awesome/icons/youtube";
    import soundcloud from "svelte-awesome/icons/soundcloud";
    import twitter from "svelte-awesome/icons/twitter";
    import snapchat from "svelte-awesome/icons/snapchat";

    export let event;

    function getIcon(providerId) {
        switch(providerId) {
            case 1:
                return facebook;
            case 2:
                return globe;
            case 3:
                return instagram;
            case 4:
                return youtube;
            case 5:
                return soundcloud;
            case 6:
                return twitter;
            case 7:
                return snapchat;
        }
        return globe;
    }
</script>

<div>
    {#each event.external_url as { id, provider, title, url }}
        <div>
            <Icon data={getIcon(provider)}/>
            <a href="{url}" rel="noreferrer" target="_blank">{title}</a>
        </div>
    {/each}
</div>

<style>
</style>